import Button from "../../common/Button";
import Table from "../../common/Table";
import { notify } from "../../common/Toast";
import { salesOrderMaster } from "../../utlis/apiService";
import InputField from "../../common/InputField";
import { IoMdClose } from "react-icons/io";
import { FaPaperPlane, FaWeightHanging, FaBoxOpen } from "react-icons/fa";

const BatchTable = ({ batchItems, batchId, onClose }) => {
  const totalQty = batchItems.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0,
  );
  const totalWeight = batchItems
    .reduce((sum, item) => sum + Number(item.qty_Weight || 0), 0)
    .toFixed(2);

  const columns = [
    { key: "order_No", label: "SO NO." },
    { key: "cust_Name", label: "Customer" },
    { key: "dieNumber", label: "Die No." },
    { key: "currentWeight", label: "Current Weight" },
    { key: "profile_Length", label: "Cut Length" },
    { key: "qty", label: "Pcs" },
    { key: "qty_Weight", label: "Weight" },
    { key: "alloy_Name", label: "Alloy" },
    { key: "req_Delivery", label: "Dispatch Date" },
    { key: "status", label: "Days to Dispatch" },
  ];

  const handleSendToProduction = async () => {
    try {
      const selectedIds = batchItems.map((item) => item.id);
      if (!selectedIds.length) {
        notify("No items in batch", "error");
        return;
      }
      await salesOrderMaster.SendToProdcution(selectedIds);
      onClose();
      notify("Batch sent to production successfully!", "success");
    } catch (error) {
      console.error("SendToProduction Error:", error);
      notify("Failed to send batch to production", "error");
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[92vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
        <div className="flex justify-between items-center bg-gradient-to-r from-primary to-blue-700 text-white p-5 px-6">
          <div>
            <h2 className="text-2xl font-bold tracking-tight">
              Production Batch Sheet
            </h2>
            <p className="text-blue-100 text-sm opacity-80">
              Finalize orders for the production line
            </p>
          </div>
          <button
            onClick={onClose}
            className="hover:bg-white/20 p-2 rounded-full transition-colors"
          >
            <IoMdClose size={28} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="bg-blue-50 border border-blue-100 p-4 rounded-lg flex items-center gap-4">
              <div className="bg-blue-500 p-3 rounded-lg text-white">
                <FaBoxOpen size={20} />
              </div>
              <div>
                <p className="text-xs text-blue-600 font-bold uppercase">
                  Total Quantity
                </p>
                <p className="text-xl font-black text-slate-800">
                  {totalQty}{" "}
                  <span className="text-sm font-normal text-slate-500">
                    pcs
                  </span>
                </p>
              </div>
            </div>
            <div className="bg-emerald-50 border border-emerald-100 p-4 rounded-lg flex items-center gap-4">
              <div className="bg-emerald-500 p-3 rounded-lg text-white">
                <FaWeightHanging size={20} />
              </div>
              <div>
                <p className="text-xs text-emerald-600 font-bold uppercase">
                  Total weight
                </p>
                <p className="text-xl font-black text-slate-800">
                  {totalWeight}{" "}
                  <span className="text-sm font-normal text-slate-500">kg</span>
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-lg border border-slate-200 shadow-sm overflow-hidden">
            <Table columns={columns} data={batchItems} showActions={false} />
          </div>

          <div className="mt-8 bg-slate-50 rounded-xl p-6 border border-slate-200 flex flex-col md:flex-row items-end justify-between gap-6">
            <div className="w-full md:max-w-xs">
              <label className="block mb-2 text-sm font-bold text-slate-700">
                Next Production Batch Id
              </label>
              <div className="bg-white">
                <InputField value={batchId} disabled />
              </div>
            </div>

            <div className="flex gap-3">
              <Button
                text="Discard Batch"
                className="bg-white border border-slate-300 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all px-6 py-2.5 rounded-lg font-semibold"
                onClick={onClose}
              />
              <Button
                text="Send to Production"
                className="bg-orange text-white shadow-lg shadow-orange transition-all px-8 py-2.5 rounded-lg font-bold flex items-center"
                icon={FaPaperPlane}
                iconSpacing="mr-2"
                onClick={handleSendToProduction}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchTable;
